import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-14-small', 'Number14Small', [["path",{"d":"M8 8h1v8"}],["path",{"d":"M13 8v3a1 1 0 0 0 1 1h3"}],["path",{"d":"M17 8v8"}]]);